export const FETCH_MODULE = 'FETCH_MODULE';
export const FETCH_MODULE_SUCCESS = 'FETCH_MODULE_SUCCESS';
export const FETCH_MODULE_FAIL = 'FETCH_MODULE_FAIL';

export const GET_MODULE = 'GET_MODULE';
export const GET_MODULE_SUCCESS = 'GET_MODULE_SUCCESS';
export const GET_MODULE_FAIL = 'GET_MODULE_FAIL';
